/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.5.0",
  "gitBuildTime": "2026-04-24T19:10:52.013Z",
  "gitBuildVersion": "1.5.0",
  "gitCommitId": "02a05ee",
  "gitCommitIdFull": "02a05ee27dc1fe3080bb523f362149e30c673371",
  "gitCommitTime": "2026-04-24T19:09:21.000Z",
  "version": "1.5.0-2026-04-24T19:09:21.000Z-(02a05ee)"
};
